import Button from 'components/ReusableComponents/Button'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import useForm from 'hooks/useForm'
import { useEffect, useState } from 'react'
import CreatableSelect from 'react-select/creatable'
import { useToasts } from 'react-toast-notifications'
import pmsApi from 'services/api/pms'

import styles from '../MultiStepPMSLogin.module.scss'

const PartnerRegistration = ({ setUpdateConfig }) => {
  const { addToast } = useToasts()
  const [formData, handleFormChange, setFormData] = useForm({
    hubId: '',
    loginUrl: '',
    propertyId: '',
    step: 'Step1PartnerRegistration'
  })
  const [hubIds, setHubIds] = useState([{ value: '', label: '' }])
  const [shouldAskLoginURL, setShouldAskLoginURL] = useState(
    formData.loginUrl ? false : true
  )

  useEffect(() => {
    pmsApi.getOhipTenants().then(res => {
      setHubIds(res.map(r => ({ value: r.hubId, label: r.hubId })))
    })
  }, [])

  const handleChangeHubId = (newValue, actionMeta) => {
    if (actionMeta.action === 'create-option') {
      setShouldAskLoginURL(true)
      setFormData({ hubId: newValue.value })
      return
    }

    if (actionMeta.action === 'clear') {
      setShouldAskLoginURL(false)
      setFormData({ hubId: null })
      return
    }

    if (actionMeta.action === 'select-option') {
      setShouldAskLoginURL(false)
      setFormData({ hubId: newValue.value })
    }
  }

  const handleFormSubmission = e => {
    e.preventDefault()
    pmsApi
      .setOhipConfiguration(formData)
      .then(() =>
        addToast('Successful', {
          appearance: 'success',
          autoDismiss: true
        })
      )
      .catch(error => {
        addToast(`${error}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => setUpdateConfig(prev => prev + 1))
  }

  return (
    <div className={styles.stepActions}>
      <form className={styles.actionContainer} onSubmit={handleFormSubmission}>
        <div className={styles.inputContainer}>
          <label className={styles.comboboxContainer}>
            <p className={styles.label}>Hub id</p>
            <CreatableSelect
              onChange={handleChangeHubId}
              options={hubIds}
              placeholder="Select or add one"
              className={styles.combobox}
              required
            />
          </label>
        </div>
        {shouldAskLoginURL && (
          <div className={styles.inputContainer}>
            <TextInput
              name="loginUrl"
              className={styles.textInput}
              type="string"
              label="Login URL"
              value={formData.loginUrl}
              onChange={handleFormChange}
              required
            />
          </div>
        )}
        <div className={styles.inputContainer}>
          <TextInput
            name="propertyId"
            className={styles.textInput}
            type="string"
            label="Property id"
            value={formData.propertyId}
            onChange={handleFormChange}
            required
          />
        </div>
        <div className={styles.inputContainer}>
          <Button type="primary" size="small">
            Next
          </Button>
        </div>
      </form>
    </div>
  )
}

export default PartnerRegistration
